import React from 'react';
import IssueGrid from './IssueGrid';

import { IssueHistory } from './IssueHistory'



export default function IssueDetails({ issue, reloadDate, parents, reload}) {
    return (
        <div>
            <IssueGrid issue={issue} reload={reload} />
            <IssueHistory parents={parents} current={issue} reload={true}  reloadDate={reloadDate} />
        </div>
    )
}